var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipSolidWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipSolidWall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SolidWall"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.69 45.52 36.69 13.2 8.46 3.04 8.46 35.36 36.69 45.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.69 45.52 39.52 43.94 39.52 11.62 36.69 13.2 36.69 45.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.69 13.2 39.52 11.62 11.29 1.46 8.46 3.04 36.69 13.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.46,
    y1: 35.36,
    x2: 36.69,
    y2: 45.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.69,
    y1: 45.52,
    x2: 36.69,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.69,
    y1: 13.2,
    x2: 8.46,
    y2: 3.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.46,
    y1: 3.04,
    x2: 8.46,
    y2: 35.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.29,
    y1: 1.46,
    x2: 39.51,
    y2: 11.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.51,
    y1: 11.62,
    x2: 39.51,
    y2: 43.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.51,
    y1: 43.94,
    x2: 36.69,
    y2: 45.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.51,
    y1: 11.62,
    x2: 36.69,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.29,
    y1: 1.46,
    x2: 8.46,
    y2: 3.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipSolidWall);
export default __webpack_public_path__ + "static/media/IconChipSolidWall.f7fd3f63f9dc38e1988576d89e2380f9.svg";
export { ForwardRef as ReactComponent };